import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import order from './modules/order'
import user from './modules/user'
import http from './modules/http'
import VuexPersist from 'vuex-persist'

require('es6-promise').polyfill();

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
    key: 'eda-orders', // The key to store the state on in the storage provider.
    storage: window.localStorage, // or window.sessionStorage or localForage
    // Function that passes the state and returns the state with only the objects you want to store.
    // reducer: state => state,
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
})

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    actions,
    getters,
    modules: {
        order,
        user,
        http
    },
    strict: false, // debug,
    plugins: [vuexLocalStorage.plugin]
})
